import { render, staticRenderFns } from "./dashboard-admin.vue?vue&type=template&id=779140a6&scoped=true"
import script from "./dashboard-admin.vue?vue&type=script&lang=js"
export * from "./dashboard-admin.vue?vue&type=script&lang=js"
import style0 from "./dashboard-admin.vue?vue&type=style&index=0&id=779140a6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779140a6",
  null
  
)

export default component.exports